export default {
    COMPANY_NAME: "Enter your company as you'd like\nit shown on your badge",
    COUNTRY_REGISTRATION: "If your country isn't listed, we may not be able\nto register you. Contact us at support@example.com\nif you'd like to check.",
}